"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _shortid = _interopRequireDefault(require("shortid"));

// A passthrough method to prepend fd- to every automatically generated ID.
function generate() {
  return 'fd-' + _shortid.default.generate();
}

var _default = {
  generate: generate
};
exports.default = _default;